module.exports = __webpack_public_path__ + "static/media/food-tech.00b54958.jpg";